module.exports = __webpack_public_path__ + "img/DealerIcons-HundredSeries-On.c23deae.jpg";